<template>
  <div
    style="position:relative;height:100%;"
  >
    <div
        class="header"
        style="padding: 25px;text-align:left;z-index:4;border-bottom: 1px solid rgba(0,0,0,0.1);background:white;padding-top: var(--mobile-padding-top, 25px);"
    >
        <h1>
            Messages
        </h1>
        <span style="font-weight: normal;">Your messages with <span class="legalFoot"></span></span>
        <v-btn
            v-if="getDomainInfo  && getDomainInfo.info && getDomainInfo.info.messages"
            fab
            color="primary"
            @click="infoDialog = true"
            style="position:absolute;right:20px;top: 20px;"
        >
            <v-icon>
                mdi-help
            </v-icon>
        </v-btn>
    </div>
    <div
        class="messages"
        :class="{ 'mobile-messages': $vuetify.breakpoint.xs}"
        ref="messageContainer"
        id="scroll-target"
        v-on:scroll="handleScroll"
    >
        <div
            v-if="noMoreMessages && messages.length > 0"
            class="last-message"
            style="text-align:center;padding: 15px;opacity:0.3;z-index:0;"
        >
            <v-icon
                color="262626"
                size="38"
            >
                mdi-timeline-clock
            </v-icon>
            <br />
            <span>End of Message History</span>
        </div>
        <div
            v-if="messages.length == 0"
            class="last-message"
            style="position:relative;margin:auto;margin-top:100px;font-size:24px;vertical-align:middle;text-align:center;opacity:0.3;z-index:0;border-radius: 50%;background-color: rgba(0,0,0,0.06);width:420px;height:420px;"
        >
            <div
                style="position:absolute;top:115px;text-align:center;width:100%;"
            >
                <v-icon
                    color="262626"
                    size="72"
                >
                    mdi-message-outline
                </v-icon>
                <br />
                <span>No Messages<br /><b>Start a new message?</b></span>
            </div>
        </div>
        <ul>
            <li
                v-for="message in messages"
                :key="message.id"
                :class="{
                    'sent-to': message.type == 'Message from Client',
                    'sent-from': message.type == 'Message to Client'
                }"
            >
                <span
                    v-if="message.subject"
                    style="font-weight: bold;display:block;"
                >
                    Subject: {{message.subject}}
                </span>
                
                <div v-html="message.message" />
                <span style="color: rgba(0,0,0,0.5);font-size: 12px;">{{convertToCalRef(message.sent_at)}}</span>
            </li>
        </ul>
    </div>
    <div
        class="new-message-text"
    >
        <v-textarea
            v-model="newMessage"
            solo
            hide-details
            rows="1"
            placeholder="Compose a new message..."
            auto-grow
            background-color="#EEEEEE"
            autofocus
            :disabled="loading"
            class="message-text-field"
            style="max-height: 400px;"
        >
            <template v-slot:append-outer style="margin:0;">
                <v-btn
                    :loading="loading"
                    :disabled="loading || !canSendMessage"
                    fab
                    small
                    color="primary"
                    style="float:right;margin:0;"
                    @click="sendMessage()"
                >
                    <v-icon>
                        mdi-send
                    </v-icon>
                </v-btn>
            </template>
        </v-textarea>
    </div>
    <v-dialog
        v-model="infoDialog"
        width="500"
    >
        <v-card>
            <v-card-text
                v-html="getDomainInfo && getDomainInfo.info && getDomainInfo.info.messages ? getDomainInfo.info.messages : ''"
                style="max-height: 50vh;overflow-y: auto"
            />
            <v-card-actions
                style="background: #E0E0E0;"
            >
                <v-spacer />
                <v-btn
                    @click="infoDialog = false"
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import api from '@/api'

export default {
    name: 'Messages',
    data () {
        return {
            messages: [],
            loading: false,
            newMessage: '',
            scroll_down: true,
            page: 1,
            count: 0,
            max_pages: 0,
            infoDialog: false
        }
    },
    created () {
        this.fetchMessages()
    },
    computed: {
        noMoreMessages () {
            if (this.count < 5) {
                return true
            }
            if (this.page === this.max_pages) {
                return true
            }
            return false
        },
        canSendMessage () {
            return /\S/.test(this.newMessage)
        }
    },
    methods: {
        handleScroll (e) {
            if (e.target.scrollTop < 250 && !this.loading && !this.noMoreMessages) {
                this.page++
                this.fetchMessages()
            }
        },
        fetchMessages () {
            this.loading = true
            api.users.client_messages.get({ pageNum: this.page, count: 10, ordering: '-sent_at' })
                .then(data => {
                    data.results.forEach((message) => {
                        message.expand = false
                        this.messages.unshift(message)
                    })
                    this.loading = false
                    this.count = data.count
                    this.page = data.page_number
                    this.max_pages = data.num_pages
                })
                .finally(() => {
                    if (this.scroll_down) {
                        this.$refs.messageContainer.scrollTop = Math.floor (this.$refs.messageContainer.scrollHeight)
                        this.scroll_down = false
                    }
                })
        },
        sendMessage() {
            if (this.canSendMessage) {
                this.loading = true
                api.users.client_messages.send({
                    'body': this.newMessage,
                })
                .then(() => {
                    this.newMessage = ''
                    this.messages = []
                    this.page = 1
                    this.loading = false
                    this.scroll_down = true
                    this.displayMessageEditor = false
                    this.directMessageSubject = ''
                    this.fetchMessages()
                })
            }
        }
    }
}
</script>

<style>
    .header {
        position:absolute;
        top:0 !important;
        right:0;
        left:0;
    }

    .message-text-field .v-input__append-outer {
        margin-top: 5px !important;
    }

    .messages {
        padding: 15px;
        max-height: calc(100vh - 71px);
        overflow-y: auto;
        overflow-x: hidden;
        margin-bottom: 5px;
    }

    .mobile-messages {
        max-height: calc(100vh - 71px - 56px) !important;
    }

    .messages ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .messages ul li{
        display:inline-block;
        clear: both;
        padding: 15px;
        border-radius: 30px;
        margin-bottom: 2px;
        font-family: Helvetica, Arial, sans-serif;
    }

    .last-message{
        margin-top: 92px;
    }

    .sent-from{
        background: #fff;
        float: left;
        border-bottom-left-radius: 5px !important;
    }

    .sent-to{
        float: right;
        background: #0084ff;
        color: #fff;
        border-bottom-right-radius: 5px !important;
    }

    .sent-from + .sent-to{
        margin-top:10px;
    }

    .sent-to + .sent-from{
        margin-top:10px;
    }

    .message-text-field textarea {
        max-height: 300px;
        overflow: auto !important;
    }

    .new-message-text {
        background-color:white;
        position:absolute;
        bottom:0;
        right:0;
        left:0;
        width:100%;
        padding:10px;
        border-top: 1px solid black;
        border-bottom: 1px solid #EEE;
        z-index: 3;
        max-height: 400px;
    }
</style>